export class TalepOnaylaRequest {
  talepId: number;
  talepOnaySeviyeId: number;
  isOnay: boolean;

}
